import { shape, number, string, arrayOf, bool, objectOf, oneOfType } from "prop-types";

export const communicationType = shape({
  id: number,
  subscriberId: number,
  userId: number,
  title: string,
  date: string,
  type: number,
  photo: string,
  bodyMessage: string,
  cover: string,
  button: shape({
    text: string,
    link: string
  }),
  event: shape({
    date: string,
    location: string
  }),
  attachments: arrayOf(objectOf(oneOfType([string, number, bool]))),
  interaction: shape({
    clickedAt: string,
    openedAt: string,
    hadInterestAt: string,
    confirmedPresenceAt: string,
    hasAck: bool
  })
});

export const communicationStateType = shape({
  communications: arrayOf(communicationType),
  count: number,
  page: number,
  unread: number
});

export const notificationStateType = shape({
  notifications: arrayOf(
    shape({
      id: number,
      type: string,
      modelId: number,
      title: string,
      createdAt: string,
      opened: bool
    })
  ),
  count: number,
  page: number,
  unread: number
});
